<script>

	/*
	*
		* importing...
	 *
	*/
	import Login from "./Login.svelte"

</script>

<div class="w-100 h-100 d-flex flex-column text-center align-items-center justify-content-center py-3">
	
	<h1 class="fs-1 text-light"> Welcome! </h1>
	<p class="my-2 text-light"> This is a page created using Node and Svelte, please enjoy</p>
<!-- 
	--
	   componentes 
	--
-->
	<Login />

</div>

<style></style>
